module.exports = {
	"Play": "Phát",
	"Pause": "Tạm dừng",
	"Current Time": "Thời gian hiện tại",
	"Duration Time": "Độ dài",
	"Remaining Time": "Thời gian còn lại",
	"Stream Type": "Kiểu Stream",
	"LIVE": "TRỰC TIẾP",
	"Loaded": "Đã tải",
	"Progress": "Tiến trình",
	"Fullscreen": "Toàn màn hình",
	"Non-Fullscreen": "Thoát toàn màn hình",
	"Mute": "Tắt tiếng",
	"Unmute": "Bật âm thanh",
	"Playback Rate": "Tốc độ phát",
	"Subtitles": "Phụ đề",
	"subtitles off": "Tắt phụ đề",
	"Captions": "Chú thích",
	"captions off": "Tắt chú thích",
	"Chapters": "Chương",
	"You aborted the media playback": "Bạn đã hủy việc phát media.",
	"A network error caused the media download to fail part-way.": "Một lỗi mạng dẫn đến việc tải media bị lỗi.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video không tải được, mạng hay server có lỗi hoặc định dạng không được hỗ trợ.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Phát media đã bị hủy do một sai lỗi hoặc media sử dụng những tính năng trình duyệt không hỗ trợ.",
	"No compatible source was found for this media.": "Không có nguồn tương thích cho media này."
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/vi.json
// module id = 206
// module chunks = 83